@import "../../../../../../globalStyles/commons";

:host {
  display: block;
}

.background {
  .row {
    display: flex;
    height: 2rem;
    border-bottom: 1px dashed var(--scale-color);

    &.hour {
      border-bottom: 1px solid var(--scale-color);
    }

    &:last-child {
      border-bottom: 0;
    }

    .column {
      flex: 1;
      border-right: 1px solid var(--scale-color);
    }
  }
}
